import { useEffect } from "react";

export const useBeforeUnload = (enabled=true)=>{
    useEffect(()=>{
        if (!enabled) { return; }

        const beforeUnload = event=>{
            event.preventDefault();
            event.returnValue = "";
        };

        window.addEventListener("beforeunload", beforeUnload);
        return _=>window.removeEventListener("beforeunload", beforeUnload);
    }, [enabled]);
};
